import { Theme } from 'config';

const styles = (theme: Theme) => ({
  container: {
    display: 'flex',
    width: '100%',
    padding: '1rem',
    justifyContent: 'space-between',

    '& > div': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  header: {
    '& *': {
      color: '#646464 !important',
    },
  },
  exportTitle: {
    padding: '0.750rem !important',
    fontSize: '.850em',
    color: theme.darkGray,
  },
  noPadding: {
    paddingBottom: '0 !important',
  },
  noBorder: {
    border: '0 !important',
  },
});

export default styles;
